import { render } from "./ListeIncotermPage.vue?vue&type=template&id=be2160c0&ts=true"
import script from "./ListeIncotermPage.vue?vue&type=script&lang=ts"
export * from "./ListeIncotermPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__